export default {
  arrow: true,
  allowHTML: true,
  interactive: true,
  theme: "sh-widget",
};
